/**
 * Decodes HTML entities in text using browser's built-in parser
 * @param text - Text that may contain HTML entities
 * @returns Decoded text
 */
export const decodeHtmlEntities = (text: string): string => {
  if (!text) return "";

  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};
